import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClosed = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 218 306",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("filter", {
		x: "-1.5%",
		y: "-1.1%",
		width: "103%",
		height: "102.1%",
		filterUnits: "objectBoundingBox",
		id: "a",
		children: /* @__PURE__ */ _jsx("feGaussianBlur", {
			stdDeviation: 1,
			in: "SourceGraphic"
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2)",
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("rect", {
			className: "slide-down",
			fill: "#483D9F",
			filter: "url(#a)",
			y: 24,
			width: 200,
			height: 280,
			rx: 4
		}), /* @__PURE__ */ _jsxs("g", {
			className: "slide-up",
			transform: "translate(16)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					fill: "#FFF",
					width: 200,
					height: 280,
					rx: 4
				}),
				/* @__PURE__ */ _jsxs("g", {
					fill: "#1fb790",
					fillRule: "nonzero",
					children: [/* @__PURE__ */ _jsx("path", { d: "M100 48c-8.81 0-16 7.19-16 16 0 8.81 7.19 16 16 16 8.81 0 16-7.19 16-16 0-8.81-7.19-16-16-16zm0 28.95c-7.147 0-12.95-5.803-12.95-12.95 0-7.147 5.803-12.95 12.95-12.95 7.147 0 12.95 5.803 12.95 12.95 0 7.147-5.803 12.95-12.95 12.95z" }), /* @__PURE__ */ _jsx("path", { d: "M105.376 66.283l4.437-5.035-6.485-1.28-3.221-5.781-3.435 5.781-6.485 1.28 4.437 5.035.021-.043v.043l-.661 6.677L100 70.208l6.016 2.752-.661-6.656z" })]
				}),
				/* @__PURE__ */ _jsx("g", {
					fill: "#F5F4FF",
					fillRule: "nonzero",
					children: /* @__PURE__ */ _jsx("path", { d: "M107.874 246.438a.381.381 0 0 0-.21-.23l-1.453-.669a.225.225 0 0 0-.169-.02.348.348 0 0 0-.316.187c-.968 1.61-1.894 2.321-3.558 2.719a5.02 5.02 0 0 1-1.2.167c-3.01.125-4.294-2.51-4.842-4.747a.416.416 0 0 0-.168-.25.408.408 0 0 0-.21-.063c-.022 0-.064 0-.085.02l-1.62.419a.303.303 0 0 0-.232.188c-.064.084-.064.188-.043.293 1.137 4.223 3.474 6.46 6.758 6.482.358.062.8.334 1.18.564.378.23.652.397.883.377.022 0 .085 0 .106-.021.273-.063.463-.356.716-.774.189-.293.4-.627.652-.878 1.6-.648 2.716-1.652 3.79-3.45a.401.401 0 0 0 .02-.314zM107.074 238.89c.063-.084.063-.21.042-.293-1.369-5.562-4.969-6.252-6.99-6.189-.252 0-.505.042-.758.063h-.042c-.063 0-.147 0-.252-.042-.232-.48-.485-.899-.78-1.275-.547-.69-1.347-1.36-2.378-1.987a.427.427 0 0 0-.232-.062c-.02 0-.063 0-.084.02-.105.021-.19.105-.253.21l-.42.836a.417.417 0 0 0 .105.502c.379.292.694.606.926.899.295.397.568.878.779 1.422a.92.92 0 0 1-.316.209c-2.105.752-5.453 2.927-3.958 8.99a.373.373 0 0 0 .19.252.427.427 0 0 0 .231.062c.021 0 .063 0 .084-.02l13.874-3.43a.441.441 0 0 0 .232-.167zm-8.148.23a.73.73 0 0 1-.884-.523c-.105-.397.147-.773.526-.878a.73.73 0 0 1 .885.523.714.714 0 0 1-.527.878zm.674-2.593a.73.73 0 0 1-.884-.522c-.105-.398.147-.774.526-.879a.73.73 0 0 1 .884.523c.085.397-.147.795-.526.878zm1.81 1.987a.73.73 0 0 1-.884-.523c-.105-.397.148-.774.527-.878a.73.73 0 0 1 .884.522.74.74 0 0 1-.526.879zm.653-2.593a.73.73 0 0 1-.884-.523c-.105-.397.147-.773.526-.878a.73.73 0 0 1 .884.523.717.717 0 0 1-.526.878zm1.81 1.986a.73.73 0 0 1-.884-.522c-.105-.398.148-.774.527-.879a.73.73 0 0 1 .884.523.717.717 0 0 1-.526.878z" })
				}),
				/* @__PURE__ */ _jsxs("g", {
					transform: "translate(24 104)",
					fill: "#F5F4FF",
					children: [
						/* @__PURE__ */ _jsx("rect", {
							width: 152,
							height: 16,
							rx: 2
						}),
						/* @__PURE__ */ _jsx("rect", {
							y: 24,
							width: 152,
							height: 16,
							rx: 2
						}),
						/* @__PURE__ */ _jsx("rect", {
							y: 72,
							width: 152,
							height: 16,
							rx: 2
						}),
						/* @__PURE__ */ _jsx("rect", {
							y: 48,
							width: 72,
							height: 16,
							rx: 2
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 80,
							y: 48,
							width: 72,
							height: 16,
							rx: 2
						})
					]
				})
			]
		})]
	})]
});
export default SvgClosed;
